export default {"src":"/_next/static/media/user-tie.c553ff7d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};